import React from "react";

import styles from "./FooterContent.module.sass";
import { withRouter } from "react-router";
import useSticky from "../../hooks/useSticky";

function FooterContent(props) {
  const [ref, sticky] = useSticky(props.ibc ? -10 : 60);
  return (
    <div
      className={`${styles.footerContent} ${
        props.sticky && sticky ? styles.sticky : ""
      } ${props.canSticky ? styles.canSticky : ""}`}
      ref={ref}
    >
      <label
        onClick={() => props.history.push({ pathname: props.path })}
        className={styles.link}
        role="link"
      >
        <i className="icon icon-seta-esquerda" />
        Voltar
      </label>

      <div className={styles.textFooter}>
        {!props.children && (
          <>
            <span className={styles.mainText}>{props.mainText}</span>
            {props.text}
          </>
        )}
        {props.children}
      </div>
    </div>
  );
}

export default withRouter(FooterContent);
